module.exports = __webpack_public_path__ + "img/upload.1bec099c.svg";